module.exports = __webpack_public_path__ + "img/noClass.2b856af8.png";